'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Settings = exports.Separator = exports.Entry = exports.SideBar = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SideBar = exports.SideBar = function (_Component) {
	_inherits(SideBar, _Component);

	function SideBar() {
		_classCallCheck(this, SideBar);

		return _possibleConstructorReturn(this, Object.getPrototypeOf(SideBar).apply(this, arguments));
	}

	_createClass(SideBar, [{
		key: 'render',
		value: function render() {
			var className = this.props.withIcon ? 'with-icon' : '';
			return React.createElement(
				'div',
				{ id: 'app-navigation' },
				React.createElement(
					'ul',
					{ className: className },
					this.props.children
				)
			);
		}
	}]);

	return SideBar;
}(_react.Component);

var Entry = exports.Entry = function (_Component2) {
	_inherits(Entry, _Component2);

	function Entry() {
		_classCallCheck(this, Entry);

		return _possibleConstructorReturn(this, Object.getPrototypeOf(Entry).apply(this, arguments));
	}

	_createClass(Entry, [{
		key: 'render',
		value: function render() {
			var className = this.props.icon ? 'icon-' + this.props.icon : '';
			return React.createElement(
				'li',
				{ className: this.props.className || '' },
				React.createElement(
					'a',
					{ className: className, onClick: this.props.onClick || function () {} },
					this.props.children
				)
			);
		}
	}]);

	return Entry;
}(_react.Component);

var Separator = exports.Separator = function (_Component3) {
	_inherits(Separator, _Component3);

	function Separator() {
		_classCallCheck(this, Separator);

		return _possibleConstructorReturn(this, Object.getPrototypeOf(Separator).apply(this, arguments));
	}

	_createClass(Separator, [{
		key: 'render',
		value: function render() {
			return React.createElement('li', { className: 'app-navigation-separator' });
		}
	}]);

	return Separator;
}(_react.Component);

var Settings = exports.Settings = function (_Component4) {
	_inherits(Settings, _Component4);

	function Settings() {
		var _Object$getPrototypeO;

		var _temp, _this4, _ret;

		_classCallCheck(this, Settings);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this4 = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Settings)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this4), _this4.state = {
			show: false
		}, _this4.toggle = function () {
			var show = !_this4.state.show;
			_this4.setState({ show: show });
		}, _temp), _possibleConstructorReturn(_this4, _ret);
	}

	_createClass(Settings, [{
		key: 'render',
		value: function render() {
			var title = this.props.title ? this.props.title : 'Settings';
			var style = {
				display: this.state.show ? 'block' : 'none'
			};

			return React.createElement(
				'div',
				{ id: 'app-settings' },
				React.createElement(
					'div',
					{ id: 'app-settings-header' },
					React.createElement(
						'button',
						{ className: 'settings-button',
							onClick: this.toggle },
						title
					)
				),
				React.createElement(
					'div',
					{
						style: style },
					this.props.children
				)
			);
		}
	}]);

	return Settings;
}(_react.Component);